export default "__VITE_ASSET__810ccc61__"